<template>
  <span class="badge" :class="badgeClass" data-test="status-badge">{{ label }}</span>
</template>

<script>
// Labels and colours for the transfer run statuses (TL-01), shared by the
// departures board and My Week. Brand dictionaries do not merge with en.js, so
// English labels are the fallback.
export const STATUS_FALLBACK = {
  wait_in_airport: 'Wait in airport', delayed: 'Delayed', loading_imminent: 'Loading imminent',
  ready_to_load: 'Ready to load', loading: 'Loading', ready_to_depart: 'Ready to depart',
  permission_to_depart: 'Permission to depart', departed: 'Departed', arrived: 'Arrived', cancelled: 'Cancelled'
}

const BADGES = {
  wait_in_airport: 'bg-secondary-lt', delayed: 'bg-red text-white', loading_imminent: 'bg-yellow text-white',
  ready_to_load: 'bg-azure text-white', loading: 'bg-blue text-white', ready_to_depart: 'bg-purple text-white',
  permission_to_depart: 'bg-teal text-white', departed: 'bg-green text-white', arrived: 'bg-green-lt', cancelled: 'bg-dark text-white'
}

export function transferStatusLabel(status) {
  const dict = typeof __DICT__ !== 'undefined' ? (__DICT__.departuresBoard?.statuses || {}) : {}
  return dict[status] || STATUS_FALLBACK[status] || status
}

export function transferStatusBadge(status) {
  return BADGES[status] || 'bg-secondary-lt'
}
</script>

<script setup>
import {computed} from 'vue'

const props = defineProps({
  status: {type: String, required: true}
})
const label = computed(() => transferStatusLabel(props.status))
const badgeClass = computed(() => transferStatusBadge(props.status))
</script>
